export function contactWidgetInit() {
    const toggle = document.getElementById('cw-toggle');
    if (!toggle) {
        console.warn('Contact Widget toggle button not found');
        return;
    }
    const panel = document.getElementById('cw-panel');
    if (!panel) {
        console.warn('Contact Widget panel not found');
    }
    const badge = document.getElementById('cw-badge');
    if (!badge) {
        console.warn('Contact Widget badge not found');
    }

    let open = false;

    function openPanel() {
        panel.classList.remove('opacity-0', 'scale-95', 'translate-y-2', 'pointer-events-none');
        panel.classList.add('opacity-100', 'scale-100', 'translate-y-0', 'pointer-events-auto');
        toggle.setAttribute('aria-expanded', 'true');
        badge.classList.add('hidden');
        open = true;
    }

    function closePanel() {
        panel.classList.add('opacity-0', 'scale-95', 'translate-y-2', 'pointer-events-none');
        panel.classList.remove('opacity-100', 'scale-100', 'translate-y-0', 'pointer-events-auto');
        toggle.setAttribute('aria-expanded', 'false');
        open = false;
    }

    toggle.addEventListener('click', (e) => {
        e.stopPropagation();
        if (!open) openPanel(); else closePanel();
    });

    // close when clicking outside
    document.addEventListener('click', (ev) => {
        if (!open) return;
        if (!panel.contains(ev.target) && !toggle.contains(ev.target)) closePanel();
    });

    // close on ESC
    document.addEventListener('keydown', (ev) => {
        if (ev.key === 'Escape' && open) closePanel();
    });

    // Accessibility: open with keyboard (Enter / Space)
    toggle.addEventListener('keydown', (ev) => {
        if (ev.key === 'Enter' || ev.key === ' ') {
            ev.preventDefault();
            toggle.click();
        }
    });

    // Optional: hide badge after first interaction or when user has visited before
    const seen = localStorage.getItem('contactWidgetSeen');
    if (seen) badge.classList.add('hidden');
    toggle.addEventListener('click', () => localStorage.setItem('contactWidgetSeen', '1'));

    if (window.ContactWidgetConfig) {
        const cfg = window.ContactWidgetConfig;
        if (cfg.phone) document.getElementById('wa-link').href = 'https://wa.me/' + cfg.phone.replace(/\D/g, '');
        if (cfg.telegram) document.getElementById('tg-link').href = 'https://t.me/' + cfg.telegram.replace(/^@/, '');
        if (cfg.email) document.getElementById('mail-link').href = 'mailto:' + cfg.email;
    }
};
